import React from "react";
import './Institutional.css'
import Authorities from "../components/Institutional/Authorities";
import ComipInfo from "../components/Institutional/ComipInfo";
import {  useParams } from "react-router-dom";
import Convenios from "../components/Institutional/Convenios";
import NavObserver from "../components/NavObserver";
import { useDispatch, useSelector } from "react-redux";
import { getAll } from "../redux/reducer/encabezados";



const Institutional = (props) =>{
    // const seccion = props.match.params.seccion
    const encabezados = useSelector(state=>state.enc.list)
    const dispatch = useDispatch()
    React.useEffect(()=>{
        if(!encabezados) dispatch(getAll())
    },[])
    const params = useParams();
    const {seccion} = params
    return(
        <>
            {
                seccion==="autoridades" ? 
                <Authorities  /> : (
                seccion==="infoComip" ? 
                <ComipInfo  /> : 
                    <Convenios/>
                )


            }
            
        </>
        
        
    )
}

export default Institutional